const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

const getVexFlowNoteName = (midi: number) => {
    const noteIndex = midi % 12;
    const octave = Math.floor(midi / 12) - 1;
    return `${NOTE_NAMES[noteIndex]}${octave}`;
};

const DURATION_MAP: Record<number, string> = {
    1: 'w',
    0.5: 'h',
    0.25: 'q',
    0.125: '8',
    0.0625: '16',
};

const SCALES: Record<string, number[]> = {
    'C': [0, 2, 4, 5, 7, 9, 11],
    'Am': [0, 2, 4, 5, 7, 9, 11],
};

export const createRandomVexflowMelody = ({ range, key = 'C', melodyNotesLength = 10, noteLengths = [0.25], maxNotesTheSameTime = 1 }: { range: [number, number], key?: 'C' | 'Am', melodyNotesLength?: number, noteLengths?: number[], maxNotesTheSameTime?: number }) => {
    const [minMidi, maxMidi] = range;
    const allowedNotes = SCALES[key] || SCALES['C'];

    const availableMidiNotes: number[] = [];
    for (let i = minMidi; i <= maxMidi; i++) {
        if (allowedNotes.includes(i % 12)) {
            availableMidiNotes.push(i);
        }
    }

    if (availableMidiNotes.length === 0) {
        return [];
    }

    const melody: string[] = [];

    for (let i = 0; i < melodyNotesLength; i++) {
        const durationValue = noteLengths[Math.floor(Math.random() * noteLengths.length)];
        const duration = DURATION_MAP[durationValue] || 'q';

        const notesCount = Math.floor(Math.random() * maxNotesTheSameTime) + 1;
        const currentStepNotes: number[] = [];
        const notesPool = [...availableMidiNotes];

        for (let j = 0; j < notesCount; j++) {
            if (notesPool.length === 0) break;
            const randomIndex = Math.floor(Math.random() * notesPool.length);
            currentStepNotes.push(notesPool[randomIndex]);
            notesPool.splice(randomIndex, 1);
        }
        currentStepNotes.sort((a, b) => a - b);

        const formattedNotes = currentStepNotes.map(getVexFlowNoteName);

        if (formattedNotes.length === 0) {
            melody.push(`B4/${duration}/r`); // Пауза, если ничего не выбрано (fallback)
        } else if (formattedNotes.length === 1) {
            melody.push(`${formattedNotes[0]}/${duration}`);
        } else {
            melody.push(`(${formattedNotes.join(' ')})/${duration}`);
        }
    }

    return melody;
};